import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=8c7765d6&scoped=true&"
import script from "./Transfer.vue?vue&type=script&lang=js&"
export * from "./Transfer.vue?vue&type=script&lang=js&"
import style0 from "./Transfer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Transfer.vue?vue&type=style&index=1&id=8c7765d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7765d6",
  null
  
)

export default component.exports